#import "./TrainingModuleAdminFields.graphql"

mutation PublishTrainingModule($moduleId: ID!, $dueOn: ISO8601Date) {
  publishTrainingModule(input: { moduleId: $moduleId, dueOn: $dueOn }) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
    assignedCount
  }
}
